import React, { useEffect } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import shipping from "../image/shipping.webp";

const Shipping = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="mx-auto h-[600px] max-w-container p-20 text-[14px] leading-10">
        <p className="mb-8 text-[20px]">Shipping Policy</p>

        <p>
          Our company offers free standard shipping on all orders over $100. For
          orders under $100, there is a flat shipping fee. Standard shipping
          typically takes 3-5 business days to deliver the package.
        </p>
        <p>
          Please note that the delivery time may vary depending on your
          location, and we cannot guarantee an exact delivery date. Once your
          order has been shipped, we will send you a confirmation email with the
          tracking information so that you can track the status of your
          shipment.
        </p>
        <p>
          If you need your order to be delivered faster than the standard
          shipping time, you can select express shipping at checkout for an
          additional fee. This will reduce the delivery time to 2 business days.
        </p>
        <p>
          We currently only ship to USA. (Some items may be shipped to Canada,
          but not all are eligible and we do not cover any import fee)
        </p>
        <p>
          If you have any questions or concerns about your order or shipping,
          please don't hesitate to contact our customer service team.
        </p>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default Shipping;
